/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import styled, { css } from 'styled-components';
import DropdownList from './DropdownList';
import DropdownItem from './DropdownItem';
import useOutside from './useOutside';
import PrimaryBtn from '../Button/PrimaryBtn';

const StyledContainer = styled.div`
  position: relative;
`;

const StyledButtonItem = styled.div`
  margin: 10px 10px 0px 10px;
  height: 40px;
  display: flex;
  align-items: center;
  > button {
    width: 100%;
  }
`;

const StyledDropdownListContainer = styled.div`
  position: absolute;
  float: left;
  ${props =>
    props.isTop &&
    css`
      bottom: 56px;
    `}
  ${props =>
    props.itemListWidth &&
    css`
      width: ${props.itemListWidth};
    `}
  z-index: 3;
  > ul {
    overflow: auto;
    min-height: 80px;
  }
`;

const DropdownDefault = ({
  children,
  options = [],
  selected = {},
  open = false,
  isMultiSelect = false,
  applyButtonLabel = '',
  onSelectItem = () => {},
  onOpen = () => {},
  style = {},
  onTop = false,
  itemListWidth,
  name = '',
  dataPanel = false
}) => {
  const select = useRef({});
  const [openState, setOpenState] = useState(open);
  const [optionsState, setOptionsState] = useState(options);
  const [wrapperRef, outSide] = useOutside();

  useEffect(() => {
    setOptionsState(options);
  }, [options]);

  const setPreviousOptionsState = () => {
    optionsState.map(op => {
      if (op.previousSelected !== undefined) {
        op.selected = op.previousSelected;
        op.previousSelected = undefined;
      }
      op.active = false;
      return op;
    });
  };

  useEffect(() => {
    if (outSide) {
      setOpenState(false);
      setPreviousOptionsState();
      select.current = {};
    }
  }, [outSide]);

  const handleOnClick = () => {
    onOpen(!openState);
    if (!openState) {
      setPreviousOptionsState();
    }
    setOpenState(!openState);
    select.current = {};
  };

  const handleOnClickItem = (target, option) => {
    setOptionsState(
      optionsState.map(op => {
        op.active = false;
        return op;
      })
    );
    onSelectItem(target, option, name);
    setTimeout(() => setOpenState(!openState), 0);
    select.current = {};
  };

  const handleOnClickApplied = e => {
    setOptionsState(
      optionsState.map(op => {
        op.previousSelected = undefined;
        return op;
      })
    );
    setOpenState(!openState);
    onSelectItem(e, optionsState.filter(a => a.selected), name);
  };

  const updateActiveStatus = () => {
    setOptionsState(
      optionsState.map(op => {
        op.active = op.value === select.current.value;
        return op;
      })
    );
  };

  const handleOnArrowUp = (e, listTarget) => {
    const total = optionsState.length - 1;
    const findIndex = optionsState.findIndex(op => op.value === select.current.value);

    if (findIndex > 0) {
      select.current = optionsState[findIndex - 1];
      listTarget.scrollTop -= findIndex + 1 * 40;
    } else {
      select.current = optionsState[total];
      listTarget.scrollTop = listTarget.scrollHeight;
    }
    updateActiveStatus();
  };

  const handleOnArrowDown = (e, listTarget) => {
    const findIndex = optionsState.findIndex(op => op.value === select.current.value);
    const first = 0;

    if (findIndex >= 0 && findIndex < optionsState.length - 1) {
      select.current = optionsState[findIndex + 1];
      if (findIndex + 1 > 1) {
        listTarget.scrollTop += findIndex + 1 * 40;
      }
    } else {
      select.current = optionsState[first];
      listTarget.scrollTop = 0;
    }
    updateActiveStatus();
  };

  const onSelect = option => {
    setOptionsState(
      optionsState.map(op => {
        if (op.value === option.value) {
          if (op.previousSelected === undefined) {
            op.previousSelected = op.selected || false;
          }
          op.selected = !op.selected;
        }
        return op;
      })
    );
  };

  const handleOnEnter = e => {
    if (isMultiSelect) {
      onSelect({ ...select.current });
    } else {
      handleOnClickItem(e, { ...select.current });
    }
  };

  const handleOnEscape = () => {
    setOpenState(!openState);
  };

  const handleOnClickSelect = option => {
    setOptionsState(
      optionsState.map(op => {
        if (op.value === option.value) {
          if (op.previousSelected === undefined) {
            op.previousSelected = op.selected || false;
          }
          op.selected = !op.selected;
        }
        op.active = false;
        return op;
      })
    );
    select.current = option;
  };

  const childrens = React.Children.map(children, child => {
    if (!React.isValidElement(child)) {
      return child;
    }

    return React.cloneElement(child, {
      ...child.props,
      active: openState,
      onClick: handleOnClick
    });
  });

  return (
    <StyledContainer ref={wrapperRef} style={style}>
      {childrens}
      {openState && (
        <StyledDropdownListContainer itemListWidth={itemListWidth} isTop={onTop}>
          <DropdownList
            onArrowUp={handleOnArrowUp}
            onArrowDown={handleOnArrowDown}
            onEnter={handleOnEnter}
            onEscape={handleOnEscape}
          >
            {optionsState.map(option => {
              return isMultiSelect ? (
                <DropdownItem
                  checkbox
                  key={option.value}
                  id={option.value}
                  onClick={() => handleOnClickSelect({ ...option })}
                  active={option.active}
                  selected={option.selected}
                >
                  {option.label}
                </DropdownItem>
              ) : (
                <DropdownItem
                  id={option.value}
                  key={option.value}
                  onClick={a => handleOnClickItem(a, option)}
                  active={option.active}
                  selected={selected.value === option.value}
                >
                  <div data-panel={dataPanel ? `list-${option.label}` : null}>{option.label}</div>
                </DropdownItem>
              );
            })}
            {isMultiSelect && (
              <StyledButtonItem>
                <PrimaryBtn size={100} onClick={() => handleOnClickApplied()}>
                  {applyButtonLabel}
                </PrimaryBtn>
              </StyledButtonItem>
            )}
          </DropdownList>
        </StyledDropdownListContainer>
      )}
    </StyledContainer>
  );
};

export default DropdownDefault;
